module.exports = __webpack_public_path__ + "img/partner_img27.7b06a6b4.png";